<div>
     <img [src]="get_img(data)" alt="Image">
</div>